import * as fromDatatype from '../datatype-library/index';

export interface bl_hc_patient_consultation_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consultation_no: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  patient_guid: fromDatatype.GuidDataFieldInterface;
  professional_guid: fromDatatype.GuidDataFieldInterface;
  membercard_guid: fromDatatype.GuidDataFieldInterface;
  diagnosis_json: fromDatatype.DiagnosisJsonInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_hc_patient_consultation_hdr_RowClass implements bl_hc_patient_consultation_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  consultation_no: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  patient_guid: fromDatatype.GuidDataFieldInterface;
  professional_guid: fromDatatype.GuidDataFieldInterface;
  membercard_guid: fromDatatype.GuidDataFieldInterface;
  diagnosis_json: fromDatatype.DiagnosisJsonInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}